//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { /*useContext, useEffect,*/ useCallback, useContext, useEffect, useState } from 'react';
// import { useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
// import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
// import Navbar from '../helpers/Header';
// import LeftNavigation from '../LeftNavigation';
import { makeStyles, Slide } from '@material-ui/core';
import ShareIcon from '@material-ui/icons/Share';
import SimpleBar from 'simplebar-react';
import Divider from '@material-ui/core/Divider';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import EditIcon from '@material-ui/icons/Edit';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
import cx from 'clsx';
import _get from 'lodash/get';
import _noop from 'lodash/noop';
import _isNil from 'lodash/isNil';
import { differenceInDays } from 'date-fns';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import { logPageView, unsubscribeRealtimeUpdates } from '../system/firebase';
// import { PATH_BRAND } from '../system/constants';
import { AppContext, LayoutContext } from '../common/contexts';
import { setClassNameInDefns } from '../common/definitionHelper';
import { getFormattedDate, getUserDateFormat } from '../common/dateHelper';
import {
    CONFIRM_DIALOG_MESSAGE_CHANGE_BRAND_PAGE_DRAFT,
    CONFIRM_DIALOG_MESSAGE_CHANGE_BRAND_PAGE_PUBLIC,
    CONFIRM_DIALOG_TITLE_CHANGE_PROFILE_TYPE_DRAFT,
    CONFIRM_DIALOG_TITLE_CHANGE_PROFILE_TYPE_PUBLIC,
    DASHBOARD_MY_PROFILE,
    PROFILE_TYPE_DRAFT,
    PROFILE_TYPE_PUBLIC,
    PAGE_TITLE_EMP_MY_PROFILE,
    ANALYTICS_EVENT_BRAND_PAGE_PREVIEW,
    ANALYTICS_EVENT_BRAND_PAGE_PUBLISHED,
    CONFIRM_DIALOG_MESSAGE_CHANGE_EMP_PROFILE_TO_DRAFT,
} from '../common/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------
import { logEvent } from '../system/firebase';
import { changeEmpProfileToDraft, loadProfileByEmployerId, saveProfileType } from '../common/services/empMyProfileServices';
import { updateMyProfileReminderDts } from '../common/services/empDashboardServices';

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdPageHead from '../common/elemental/AfitdPageHead';
import AfitdTypography from '../common/elemental/AfitdTypography';
import AfitdButtonGroup from '../common/elemental/AfitdButtonGroup';
import AfitdButton from '../common/elemental/AfitdButton';
import AfitdEditDialog from '../common/elemental/AfitdEditDialog';
import AfitdIconButton from '../common/elemental/AfitdIconButton';
import SocialMediaPortfolio from '../dashboardMyProfile/subComponents/SocialMediaPortfolio';
import BrandPage from '../empBrandPage/subComponents/BrandPage';
import ShareButtonBar from '../dashboardMyProfile/subComponents/ShareButtonBar';
import AfitdConfirmDialog from '../common/elemental/AfitdConfirmDialog';
import Footer from '../dashboard/subComponents/Footer';
import ShareButtonMenu from './subComponents/ShareButtonMenu';
import AfitdTour from '../common/elemental/AfitdTour';
import AfitdTourStepContent from '../common/elemental/AfitdTourStepContent';
import AfitdTourStepEndContent from '../common/elemental/AfitdTourStepEndContent';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
import CompanyInfo from './subComponents/CompanyInfo';
import Branding from './subComponents/Branding';
import AfitdFab from '../common/elemental/AfitdFab';
// import SocialMediaPortfolio from './subComponents/SocialMediaPortfolio';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    const { isPublic } = params;

    return makeStyles(theme => ({
        root: {
            height: '100%',
            background: '#FAFAFC',
        },
        header: {
            height: '128px',
        },
        helpIconContainer: {
            marginRight: 16,
            backgroundColor: 'rgba(0, 0, 0, 0.03)',
            borderRadius: 50,
            height: 45,
            width: 45,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        viewProfileButtonContainer: {
            marginLeft: '20px',
        },
        viewProfileButton: {
            textTransform: 'none',
        },

        headerLeft: {
            display: 'flex',
            justifyContent: 'flex-start',
            flexDirection: 'column',
        },
        headerRight: {
            flexGrow: 4,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItem: 'center',
        },
        headerTitle: {
            marginTop: '38px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
            [theme.breakpoints.down('sm')]: { marginTop: '10px' },
        },
        headerToday: {
            marginTop: '7px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
        },
        headerButtons: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center',
        },
        todayIcon: {
            fontSize: '16px',
            color: 'rgba(17, 30, 20, 0.4)',
        },
        todayContainer: {
            marginTop: '1px',
            marginLeft: '9px',
            fontSize: '13px',
            color: 'rgba(17, 30, 20, 0.6)',
        },
        title: {
            fontStyle: 'normal',
            fontWeight: '500',
            fontSize: '26px',
            lineHeight: '30px',
            color: '#111E14',
            [theme.breakpoints.down('sm')]: { fontSize: '24px' },
        },
        shareContainer: {
            marginTop: '4px',
            marginLeft: '24px',
            display: 'flex',
        },
        shareIcon: {
            color: 'rgba(17, 30, 20, 0.4)',
            padding: '0 0 0 0',
            cursor: 'default',
            ...(isPublic
                ? {
                      '&:hover': {
                          cursor: 'pointer',
                          color: '#111E14',
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                      },
                  }
                : { pointerEvents: 'none' }),
        },
        shareText: {
            marginLeft: '20px',
            marginRight: '10px',
            ...(isPublic
                ? {
                      '&:hover': {
                          cursor: 'pointer',
                      },
                  }
                : { pointerEvents: 'none' }),
        },
        slideContainer: {
            overflow: 'hidden',
        },
        content: {
            flex: 1,
            overflowY: 'hidden',
            marginTop: 0,
            marginBottom: 0,
            borderRadius: 10,
            backgroundColor: '#fff',
        },
        myProfileLeft: {},
        myProfileRight: {
            overflowY: 'auto',
            height: '100%',
            '&::-webkit-scrollbar-track': {
                borderRadius: '10px',
                background: 'none',
            },
            '&::-webkit-scrollbar': {
                width: '8px',
                backgroundColor: '#F5F5F5',
            },
            '&::-webkit-scrollbar-thumb': {
                borderRadius: '10px',
                backgroundColor: 'rgba(0,0,0,0.2)',
            },
        },
        navList: {
            listStyle: 'none',
            padding: '40px 0 0 50px',
            marginTop: 0,
            marginBottom: 0,
            [theme.breakpoints.down('lg')]: {
                padding: '32px 40px 16px 40px',
                display: 'flex',
                justifyContent: 'space-between',
            },
            [theme.breakpoints.down('md')]: {
                padding: '32px 32px 16px 32px',
            },
            [theme.breakpoints.down('sm')]: {
                padding: '24px 16px 16px 16px',
            },
        },
        navItem: {
            padding: '10px 0',
            color: '#adadad',
            cursor: 'pointer',
            textAlign: 'left',
            fontSize: theme.spacing(2),
        },
        navItemActive: {
            color: 'black',
            fontWeight: 'bold',
            fontSize: theme.spacing(2),
        },
        profileContainer: {
            padding: '40px 50px 40px 0',
            [theme.breakpoints.down('lg')]: {
                padding: '32px 40px 0px 40px',
                marginBottom: 100,
            },
            [theme.breakpoints.down('md')]: {
                padding: '32px 32px 0px 32px',
                marginBottom: 100,
            },
            [theme.breakpoints.down('sm')]: {
                padding: '24px 16px 16px 16px',
                marginBottom: 70,
            },
        },
        profileLeftDivider: {
            [theme.breakpoints.down('lg')]: {
                padding: '0px 32px',
            },
            [theme.breakpoints.down('sm')]: {
                padding: '0px 16px',
            },
        },
        bottomFooter: {
            paddingTop: 10,
        },
        companyInfoMenu: {
            [theme.breakpoints.down('sm')]: {
                fontSize: '14pt',
            },
        },
        brandingMenu: {
            [theme.breakpoints.down('sm')]: {
                fontSize: '14pt',
            },
        },
        socialMediaMenu: {
            [theme.breakpoints.down('sm')]: {
                fontSize: '14pt',
            },
        },
        editFab: {
            position: 'absolute',
            [theme.breakpoints.up('md')]: { bottom: theme.spacing(4), right: theme.spacing(10) },
            [theme.breakpoints.down('md')]: { bottom: theme.spacing(8), right: theme.spacing(10) },
            [theme.breakpoints.down('sm')]: { bottom: theme.spacing(10), right: theme.spacing(2) },
            [theme.breakpoints.down('xs')]: { bottom: theme.spacing(10), right: theme.spacing(2) },
        },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        classes,
        employerId,
        currentEmployer,
        userDateFormat,
        isPublic,
        profileData,
        active,
        setActive,
        brandPageDialogOpen,
        // setBrandPageDialogOpen,
        handleClickViewProfileButton,
        handleCloseBrandPageDialog,
        shareButtonsShowing,
        setShareButtonsShowing,
        handleClickProfileTypeButton,
        confirmDialogProfileType,
        // setConfirmDialogProfileType,
        handleClickConfirmChangeProfileTypeDialogYes,
        handleCloseConfirmDChangeProfileTypeDialog,
        walkThroughTourSteps,
        makeProfilePublicTourSteps,
        shareProfileTourSteps,
        walkThroughTourOpen,
        makeProfilePublicTourOpen,
        shareProfileTourOpen,
        handleCloseTour,
        editCompanyInfoDialogOpen,
        setEditCompanyInfoDialogOpen,
        editPortfolioDialogOpen,
        setEditPortfolioDialogOpen,
        confirmEditProfileDialogOpen,
        setConfirmEditProfileDialogOpen,
        handleConfirmEditProfile,
    } = params;
    const { navItem: navItemCls, navItemActive: navItemActiveCls /*, content*/ } = classes;
    // const {
    //     publicDraftButtons: publicDraftButtonsCls,
    //     publicDraftButtonOff: publicDraftButtonOffCls,
    //     profileLink: profileLinkCls,
    //     profileLinkSelected: profileLinkSelectedCls,
    // } = classes;

    const companyInfoData = _get(profileData, 'info');
    const brandData = _get(profileData, 'brand');
    const socialMediaData = _get(profileData, 'social');

    const isCompanyInfoActive = active === MENU_COMPANY_INFO;
    const isBrandingActive = active === MENU_BRANDING;
    const isSocialMediaActive = active === MENU_SOCIAL_MEDIA;

    const tourOpen = walkThroughTourOpen || makeProfilePublicTourOpen || shareProfileTourOpen;
    const tourSteps = walkThroughTourOpen ? walkThroughTourSteps : makeProfilePublicTourOpen ? makeProfilePublicTourSteps : shareProfileTourOpen ? shareProfileTourSteps : [];

    const defns = {
        root: {
            item: true,
            container: true,
            direction: 'column',
            lg: 12,
            md: 12,
            sm: 12,
            xs: 12,
        },
        content: { container: true, item: true, spacing: 0 },
        header: { item: true, container: true },

        shareIcon: {
            onClick: isPublic ? setShareButtonsShowing.bind(null, !shareButtonsShowing) : _noop,
        },
        shareText: {
            variant: 'body2',
            value: 'Share',
            onClick: isPublic ? setShareButtonsShowing.bind(null, !shareButtonsShowing) : _noop,
        },
        shareButtonBar: {
            onClose: setShareButtonsShowing.bind(null, false),
            isEmp: true,
        },

        publicDraftButtonGroup: { disableElevation: true },
        publicButton: {
            color: profileData && isPublic ? 'secondary' : '',
            onClick: profileData && isPublic ? _noop : handleClickProfileTypeButton.bind(null, PROFILE_TYPE_PUBLIC), //setProfileType.bind(null, PROFILE_TYPE_PUBLIC),
        },
        draftButton: {
            color: profileData && !isPublic ? 'secondary' : '',
            onClick: profileData && !isPublic ? _noop : handleClickProfileTypeButton.bind(null, PROFILE_TYPE_DRAFT), //setProfileType.bind(null, PROFILE_TYPE_DRAFT),
        },

        viewProfileButtonGroup: { disableElevation: true },
        viewProfileButton: {
            color: 'primary',
            onClick: handleClickViewProfileButton,
        },

        // SIDE MENU
        myProfileLeft: { item: true, xl: 3, lg: 12, md: 12, sm: 12, xs: 12 },
        navList: {},
        companyInfoMenu: {
            className: cx(navItemCls, { [navItemActiveCls]: isCompanyInfoActive }),
            onClick: () => setActive(MENU_COMPANY_INFO),
        },
        brandingMenu: {
            className: cx(navItemCls, { [navItemActiveCls]: isBrandingActive }),
            onClick: () => setActive(MENU_BRANDING),
        },
        socialMediaMenu: {
            className: cx(navItemCls, { [navItemActiveCls]: isSocialMediaActive }),
            onClick: () => setActive(MENU_SOCIAL_MEDIA),
        },

        // CONTENT
        myProfileRight: { item: true, xl: 9, lg: 12, md: 12, sm: 12, xs: 12 },
        todayText: {
            variant: 'caption',
            value: getFormattedDate(new Date(), userDateFormat),
            clsBigCaption: true,
        },
        companyInfo: { data: companyInfoData, isPublic, editDialogOpen: editCompanyInfoDialogOpen, setEditDialogOpen: setEditCompanyInfoDialogOpen },
        branding: { data: brandData, isPublic, profileData },
        socialMedia: { data: socialMediaData, isEmp: true, isEmpProfilePublic: isPublic, editDialogOpen: editPortfolioDialogOpen, setEditDialogOpen: setEditPortfolioDialogOpen },
        brandPageDialog: {
            fullScreen: true,
            open: brandPageDialogOpen,
            // isDirty,
            onClose: handleCloseBrandPageDialog,
            hideActions: true,
        },
        brandPage: {
            employer: { ...currentEmployer, uid: employerId },
        },
        confirmChangeProfileTypeDialog: {
            title: getConfirmDialogTitle(confirmDialogProfileType === PROFILE_TYPE_PUBLIC),
            open: !!confirmDialogProfileType,
            message: getConfirmDialogMessage(confirmDialogProfileType === PROFILE_TYPE_PUBLIC),
            onConfirm: handleClickConfirmChangeProfileTypeDialogYes,
            onClose: handleCloseConfirmDChangeProfileTypeDialog,
        },
        walkThroughTour: {
            steps: tourSteps,
            open: tourOpen,
            isHidden: !tourOpen,
            onClose: handleCloseTour,
        },
        confirmEditProfileDialog: {
            maxWidth: 'sm',
            title: 'Edit Your Profile?',
            onClose: () => setConfirmEditProfileDialogOpen(false),
            onConfirm: handleConfirmEditProfile,
            open: confirmEditProfileDialogOpen,
            message: CONFIRM_DIALOG_MESSAGE_CHANGE_EMP_PROFILE_TO_DRAFT,
        },
    };

    setClassNameInDefns(defns, classes);
    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
const [MENU_COMPANY_INFO, MENU_BRANDING, MENU_SOCIAL_MEDIA] = ['companyInfo', 'branding', 'socialMedia'];

const getConfirmDialogTitle = isPublic => {
    return isPublic ? CONFIRM_DIALOG_TITLE_CHANGE_PROFILE_TYPE_PUBLIC : CONFIRM_DIALOG_TITLE_CHANGE_PROFILE_TYPE_DRAFT;
};

const getConfirmDialogMessage = isPublic => {
    return isPublic ? CONFIRM_DIALOG_MESSAGE_CHANGE_BRAND_PAGE_PUBLIC : CONFIRM_DIALOG_MESSAGE_CHANGE_BRAND_PAGE_DRAFT;
};

const getTourStepMakeProfilePublicReminder = handleCloseTour => {
    return {
        selector: '[data-tour="emp-my-profile-public-button-container"]',
        content: (
            <AfitdTourStepContent
                title="Don't forget to make your Brand Page 'Public'"
                message="Changing your status to 'Public' will make your brand page available to be reviewed and searched by job seekers."
                gotItOnClick={handleCloseTour}
            />
        ),
    };
};

const getTourStepViewProfile = handleCloseTour => {
    return {
        selector: '[data-tour="emp-view-profile-button-container"]',
        content: (
            <AfitdTourStepContent
                title="Preview what job seekers will see"
                message="Before making your Brand Page 'Public', click this button to see what it will look like."
                gotItOnClick={handleCloseTour}
            />
        ),
    };
};

const getTourStepShareProfile = handleCloseTour => {
    return {
        selector: '[data-tour="emp-share-button-container"]',
        content: (
            <AfitdTourStepContent
                title="Sharing is caring"
                message="When your Brand Page is 'Public' you can amplify your Brand Page awareness via your social media channels."
                gotItOnClick={handleCloseTour}
            />
        ),
    };
};

const getTourStepWalkThroughEnd = handleCloseTour => {
    return {
        // selector: '[data-tour="walk-through-end"]',
        content: (
            <AfitdTourStepEndContent
                title="Walk-through completed!"
                message="All the best in your talent search and we are here to help. Reach out to us via the 'Contact Us' page if you have any issues with our software."
                doneOnClick={handleCloseTour}
            />
        ),
    };
};

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const EmpMyProfile = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const theme = useTheme();
    const appContext = useContext(AppContext);
    const { userId, employerId, currentEmployer } = appContext;
    const userDateFormat = getUserDateFormat(appContext);

    const layoutContext = useContext(LayoutContext);
    const { dashboardDataEmpMember, setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;
    // const history = useHistory();
    const lgMatches = useMediaQuery(theme.breakpoints.down('lg'));
    const mdMatches = useMediaQuery(theme.breakpoints.down('md'));
    const smMatches = useMediaQuery(theme.breakpoints.down('sm'));

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const [, setProfileType] = useState();
    const [profileData, setProfileData] = useState(null);
    const [active, setActive] = useState(MENU_COMPANY_INFO);
    const [brandPageDialogOpen, setBrandPageDialogOpen] = useState(false);
    const [confirmDialogProfileType, setConfirmDialogProfileType] = useState(null);
    const [shareButtonsShowing, setShareButtonsShowing] = useState(false);
    const [walkThroughTourOpen, setWalkThroughTourOpen] = useState(false);
    const [makeProfilePublicTourOpen, setMakeProfilePublicTourOpen] = useState(false);
    const [shareProfileTourOpen, setShareProfileTourOpen] = useState(false);
    const [editCompanyInfoDialogOpen, setEditCompanyInfoDialogOpen] = useState();
    const [editPortfolioDialogOpen, setEditPortfolioDialogOpen] = useState();
    const [confirmEditProfileDialogOpen, setConfirmEditProfileDialogOpen] = useState(false);

    // share button menu state and handler
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleOpenMenu = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------
    const isProfilePublic = _get(profileData, 'isPublic');
    const showMakeProfilePublicTourStepDt = _get(dashboardDataEmpMember, 'showMakeProfilePublicTourStepDt');
    const showShareProfileTourStepDt = _get(dashboardDataEmpMember, 'showShareProfileTourStepDt');

    // never seen make-public reminder tour step and profile is Draft
    const isShowWalkThrough = profileData && !profileData.isPublic && _isNil(showMakeProfilePublicTourStepDt);

    // never seen share tour step
    const isShowFirstTimeShareTourStep = !isShowWalkThrough && profileData && _isNil(showShareProfileTourStepDt);

    // returning visitor with an active resume has not seen the reminder message for more than a week and profile is Draft
    const isShowMakePublicReminderAgain = !isShowWalkThrough && profileData && !profileData.isPublic && differenceInDays(new Date(), showMakeProfilePublicTourStepDt) > 7;

    const isPublic = _get(profileData, 'isPublic', false);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    useEffect(() => {
        logPageView(PAGE_TITLE_EMP_MY_PROFILE);
    }, []);

    useEffect(() => {
        if (profileData) {
            const isPublic = _get(profileData, 'isPublic');
            setProfileType(isPublic ? PROFILE_TYPE_PUBLIC : PROFILE_TYPE_DRAFT);
        }
    }, [profileData]);

    useEffect(() => {
        let isUpdateTimestamp = false;

        if (isShowWalkThrough || isShowFirstTimeShareTourStep || isShowMakePublicReminderAgain) {
            isShowWalkThrough && setWalkThroughTourOpen(true);
            isShowFirstTimeShareTourStep && setShareProfileTourOpen(true);
            isShowMakePublicReminderAgain && setMakeProfilePublicTourOpen(true);
            isUpdateTimestamp = true;
        }

        if (isUpdateTimestamp) {
            updateMyProfileReminderDts({ userId, employerId, isShowWalkThrough, isShowFirstTimeShareTourStep, isShowMakePublicReminderAgain });
        }
        // console.log('Temporary avoid linter warnings', setProfileMakePublicReminderDialogOpen, updateMyProfileReminderDts);
    }, [userId, employerId, isShowWalkThrough, isShowFirstTimeShareTourStep, isShowMakePublicReminderAgain]);

    useEffect(() => {
        let unsubscribeLoadProfileByEmployerId = null;
        if (employerId) {
            unsubscribeLoadProfileByEmployerId = loadProfileByEmployerId({
                employerId,
                isEmpProfilePage: true,
                setData: setProfileData,
            });
        }

        // unsubscribe realtime update on unmount
        return () => {
            unsubscribeRealtimeUpdates([unsubscribeLoadProfileByEmployerId]);
        };
    }, [employerId, setProfileData]);

    // if profile is set to DRAFT while the share menu is open, close the share menu.
    useEffect(() => {
        if (!isPublic && shareButtonsShowing) {
            setShareButtonsShowing(false);
        }
    }, [isPublic, shareButtonsShowing]);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const handleClickViewProfileButton = useCallback(() => {
        setBrandPageDialogOpen(true);
        logEvent(ANALYTICS_EVENT_BRAND_PAGE_PREVIEW);
    }, []);

    const handleCloseBrandPageDialog = useCallback(() => {
        setBrandPageDialogOpen(false);
    }, []);

    const handleClickProfileTypeButton = useCallback(profileType => {
        setConfirmDialogProfileType(profileType);
    }, []);

    const handleCloseConfirmDChangeProfileTypeDialog = useCallback(() => {
        setConfirmDialogProfileType(null);
    }, []);

    const handleClickConfirmChangeProfileTypeDialogYes = useCallback(() => {
        const isPublic = confirmDialogProfileType === PROFILE_TYPE_PUBLIC;
        saveProfileType({
            employerId,
            isPublic,
            dataDidSave: () => {
                setConfirmDialogProfileType(null);
                isPublic && logEvent(ANALYTICS_EVENT_BRAND_PAGE_PUBLISHED);
            },
            setSnackbarMessage,
            setSnackbarErrorMessage,
        });
    }, [employerId, setSnackbarMessage, setSnackbarErrorMessage, confirmDialogProfileType]);

    // const handleCloseProfileMakePublicReminderDialog = useCallback(() => {
    //     setProfileMakePublicReminderDialogOpen(false);
    // }, []);

    const handleCloseTour = useCallback(() => {
        setWalkThroughTourOpen(false);
        setMakeProfilePublicTourOpen(false);
        setShareProfileTourOpen(false);
    }, []);

    // }, [userId, isShowWalkThrough, isShowFirstTimeShareTourStep, isShowMakePublicReminderAgain]);
    const walkThroughTourSteps = [getTourStepMakeProfilePublicReminder(), getTourStepViewProfile(), getTourStepShareProfile(), getTourStepWalkThroughEnd(handleCloseTour)];
    const makeProfilePublicTourSteps = [getTourStepMakeProfilePublicReminder(handleCloseTour)];
    const shareProfileTourSteps = [getTourStepShareProfile(handleCloseTour)];

    const handleConfirmEditProfile = async () => {
        await changeEmpProfileToDraft({ employerId, setSnackbarMessage, setSnackbarErrorMessage });
    };

    const handleClickEditFab = (evt, reason) => {
        if (isProfilePublic) {
            setConfirmEditProfileDialogOpen(true);
        } else {
            switch (active) {
                case MENU_COMPANY_INFO:
                    setEditCompanyInfoDialogOpen(true);
                    break;
                case MENU_SOCIAL_MEDIA:
                    setEditPortfolioDialogOpen(true);
                    break;
                default:
                // do nothing
            }
        }
    };

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const classes = useStyles({ isPublic })();
    const defns = getDefns({
        classes,
        employerId,
        currentEmployer,
        userDateFormat,
        isPublic,
        profileData,
        active,
        setActive,
        brandPageDialogOpen,
        setBrandPageDialogOpen,
        handleClickViewProfileButton,
        handleCloseBrandPageDialog,
        shareButtonsShowing,
        setShareButtonsShowing,
        handleClickProfileTypeButton,
        confirmDialogProfileType,
        setConfirmDialogProfileType,
        handleClickConfirmChangeProfileTypeDialogYes,
        handleCloseConfirmDChangeProfileTypeDialog,
        walkThroughTourSteps,
        makeProfilePublicTourSteps,
        shareProfileTourSteps,
        walkThroughTourOpen,
        makeProfilePublicTourOpen,
        shareProfileTourOpen,
        handleCloseTour,
        editCompanyInfoDialogOpen,
        setEditCompanyInfoDialogOpen,
        editPortfolioDialogOpen,
        setEditPortfolioDialogOpen,
        confirmEditProfileDialogOpen,
        setConfirmEditProfileDialogOpen,
        handleConfirmEditProfile,
    });

    return (
        <LayoutContext.Provider value={{ ...layoutContext, profileData }}>
            <AfitdPageHead title={PAGE_TITLE_EMP_MY_PROFILE} />
            <Grid {...defns.root}>
                <Grid {...defns.header}>
                    <div {...defns.headerLeft}>
                        <div {...defns.headerTitle}>
                            <div {...defns.title}>{DASHBOARD_MY_PROFILE}</div>
                            {lgMatches ? (
                                <ShareButtonMenu open={open} handleOpenMenu={handleOpenMenu} handleCloseMenu={handleCloseMenu} anchorEl={anchorEl} smMatches={smMatches} />
                            ) : (
                                <div {...defns.shareContainer} data-tour="emp-share-button-container">
                                    <AfitdIconButton {...defns.shareIcon}>
                                        <ShareIcon />
                                    </AfitdIconButton>
                                    <AfitdTypography {...defns.shareText} />
                                    <div {...defns.slideContainer}>
                                        <Slide direction="right" in={shareButtonsShowing} timeout={500} mountOnEnter unmountOnExit>
                                            <ShareButtonBar {...defns.shareButtonBar} />
                                        </Slide>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div {...defns.headerToday}>
                            <CalendarTodayIcon {...defns.todayIcon} />
                            <div {...defns.todayContainer}>
                                <AfitdTypography {...defns.todayText} />
                            </div>
                        </div>
                    </div>
                    <div {...defns.headerRight}>
                        <div {...defns.headerButtons}>
                            {/* <div>
                                <HelpOutlineIcon {...defns.helpOutlineIcon} />
                            </div> */}
                            <div>
                                <AfitdButtonGroup variant="contained" aria-label="contained button group" {...defns.publicDraftButtonGroup}>
                                    <AfitdButton isGroup={true} {...defns.draftButton}>
                                        Draft
                                    </AfitdButton>
                                    <div data-tour="emp-my-profile-public-button-container">
                                        <AfitdButton isGroup={true} {...defns.publicButton}>
                                            Public
                                        </AfitdButton>
                                    </div>
                                </AfitdButtonGroup>
                            </div>
                            <div {...defns.viewProfileButtonContainer} data-tour="emp-view-profile-button-container">
                                <AfitdButtonGroup variant="contained" aria-label="contained button group" {...defns.viewProfileButtonGroup}>
                                    <AfitdButton isGroup={true} {...defns.viewProfileButton}>
                                        View Profile
                                    </AfitdButton>
                                </AfitdButtonGroup>
                            </div>
                        </div>
                    </div>
                </Grid>

                <Grid {...defns.content}>
                    <Grid {...defns.myProfileLeft}>
                        <ul {...defns.navList}>
                            <li {...defns.companyInfoMenu}>Company Info</li>
                            <li {...defns.brandingMenu}>Branding</li>
                            <li {...defns.socialMediaMenu}>{smMatches ? 'Social Media...' : 'Social Media and Portfolio'}</li>
                        </ul>
                        {lgMatches ? (
                            <Grid {...defns.profileLeftDivider}>
                                <Divider />
                            </Grid>
                        ) : null}
                    </Grid>

                    <Grid {...defns.myProfileRight}>
                        <SimpleBar style={{ height: '100%' }}>
                            <div {...defns.profileContainer}>
                                {active === MENU_COMPANY_INFO && <CompanyInfo {...defns.companyInfo} />}
                                {active === MENU_BRANDING && <Branding {...defns.branding} />}
                                {active === MENU_SOCIAL_MEDIA && <SocialMediaPortfolio {...defns.socialMedia} />}
                            </div>
                        </SimpleBar>
                    </Grid>
                </Grid>
                {mdMatches ? (
                    <Grid {...defns.bottomFooter}>
                        <Footer />
                    </Grid>
                ) : null}
            </Grid>
            <AfitdConfirmDialog {...defns.confirmChangeProfileTypeDialog} />
            <AfitdConfirmDialog {...defns.confirmEditProfileDialog} />
            {brandPageDialogOpen && (
                <AfitdEditDialog {...defns.brandPageDialog}>
                    <BrandPage {...defns.brandPage} />
                </AfitdEditDialog>
            )}
            <AfitdTour {...defns.walkThroughTour} />

            <AfitdFab
                isHidden={active === MENU_BRANDING}
                // size='small'
                color="primary"
                onClick={handleClickEditFab}
                {...defns.editFab}
            >
                <EditIcon />
            </AfitdFab>
        </LayoutContext.Provider>
    );
};

export default EmpMyProfile;
